import { useTelegramVerifyOTP } from "@core/shared/hooks";
import { Button, SubmitButton } from "@design-system/components/Button";
import { TextInput } from "@design-system/components/Form";
import { telegramLoginAtom } from "@framework/auth/atoms";
import { trans } from "@mongez/localization";
import { Form } from "@mongez/react-form";
import { FaTelegram } from "react-icons/fa";

export function TelegramOTPVerification() {
  const telegramLogin = telegramLoginAtom.useValue();
  const { verifyOTP } = useTelegramVerifyOTP();

  const handleBackToPhone = () => {
    telegramLoginAtom.merge({
      isOTPSent: false,
      otpCode: "",
    });
  };

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-700 dark:bg-gray-800">
      <div className="mb-6 text-center">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-blue-100 text-blue-600 dark:bg-blue-900/20 dark:text-blue-400">
          <FaTelegram size={32} />
        </div>
        <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
          {trans("auth.telegram.verifyOTP")}
        </h3>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
          {trans("auth.telegram.otpSentTo")} {telegramLogin.phoneOrEmail}
        </p>
      </div>

      <Form onSubmit={verifyOTP} className="space-y-4" id="verify-otp-form">
        {/* <OTPInput */}
        <TextInput
          name="otpCode"
          length={6}
          label={trans("auth.telegram.enterOTP")}
          required
        />

        <div className="flex gap-3">
          <Button
            type="button"
            variant="outline"
            onClick={handleBackToPhone}
            className="flex-1"
          >
            {trans("auth.telegram.back")}
          </Button>
          <SubmitButton className="flex-1">
            {trans("auth.telegram.verify")}
          </SubmitButton>
        </div>
      </Form>
    </div>
  );
}
